import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'
import {
  CheckoutRoute,
  useCheckoutRouter,
} from '@src/hooks/useCheckoutRouter/useCheckoutRouter'
import { useBasketTotalsContext } from '@src/hooks/useTotals/BasketTotalsContext'

import {
  LoyaltyCardAmountBold,
  LoyaltyCardText,
} from '../CustomerLoyaltyCard.styles'

import {
  AddOnItemsIcon,
  ExtraInfoAndAmountEarnedContainer,
  IconTextAndDetailsContainer,
  RewardNameContainer,
  TextAndIconContainer,
} from './CheckoutRewards.styles'

import { useFormatCurrency } from '@src/hooks/useFormatCurrency'

import { BasketBoostSVG } from '@src/components/SVGS/BasketBoostSVG'
import { TextClamp } from '@src/components/Text/Clamp'

export const AddOnItemsDealsSection: React.FC = () => {
  const { t } = useTranslation('customerLoyaltyCard')
  const { basketTotals } = useBasketTotalsContext()

  const outletFulfilment = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.GLOBAL,
  })

  const checkout = useCheckoutRouter()
  const formatCurrency = useFormatCurrency()

  const shouldShowBasketBoost =
    outletFulfilment.outlet.restaurant.allowAddOnItems

  const addOnItemsData =
    basketTotals.data?.checkoutBasketTotals?.addOnItemsTotal

  if (!addOnItemsData || !shouldShowBasketBoost) {
    return null
  }

  const amountToUnlockAddOns = addOnItemsData.amountToSpendToEarn

  return (
    <>
      {checkout.route !== CheckoutRoute.PAYMENT ? (
        <IconTextAndDetailsContainer>
          <TextAndIconContainer>
            <AddOnItemsIcon>
              <BasketBoostSVG id="basket-offer-item" />
            </AddOnItemsIcon>
            <RewardNameContainer color={'addOn'}>
              <TextClamp tooltipText={addOnItemsData.menuGroupName}>
                {addOnItemsData.menuGroupName}
              </TextClamp>
            </RewardNameContainer>
          </TextAndIconContainer>
          <ExtraInfoAndAmountEarnedContainer>
            {' '}
            <LoyaltyCardText isBasket={true} isTermsPage={false}>
              {amountToUnlockAddOns && amountToUnlockAddOns > 0 ? (
                <>
                  {t('add')}
                  <LoyaltyCardAmountBold isBasket={true}>
                    {' '}
                    {formatCurrency(amountToUnlockAddOns)}{' '}
                  </LoyaltyCardAmountBold>
                  {t('to_select_items')}
                </>
              ) : (
                <>{t('select_before_payment')} </>
              )}
            </LoyaltyCardText>
          </ExtraInfoAndAmountEarnedContainer>
        </IconTextAndDetailsContainer>
      ) : (
        <>
          {basketTotals?.data?.checkoutBasketTotals?.appliedDiscount !==
            null && (
            <IconTextAndDetailsContainer>
              <TextAndIconContainer isAddOnWarning>
                <AddOnItemsIcon>
                  <BasketBoostSVG id="basket-offer-item" />
                </AddOnItemsIcon>
                <RewardNameContainer color={'#2e3333'} isAddOnWarning>
                  {t('order_summary.offer_items_excluded', {
                    ns: 'checkout',
                  })}
                </RewardNameContainer>
              </TextAndIconContainer>
            </IconTextAndDetailsContainer>
          )}
        </>
      )}
    </>
  )
}
